import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import { TheWorld } from '@/components/Rankings'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'

const IndexPage = () => (
  <Layout>
    <SEO
      title="THE World University Ranking 2022"
      keywords={[
        `La Tercera`,
        `Ranking THE`,
        `Universidades Chilenas en el extranjero`,
      ]}
    />
    <Content>
      <h1>
        <strong>THE</strong> World University Ranking 2022
      </h1>
      <Columns>
        <p>
          El 2 de septiembre, Times Higher Education (THE) publicó su ranking
          mundial, en el que por sexto año consecutivo la tabla es encabezada
          por la U. de Oxford. Detrás de la británica, empataron en el segundo
          puesto las estadounidenses CALTECH y Harvard, mientras que Stanford
          ocupó la cuarta posición. Otro empate se dio entre el MIT y Cambridge,
          quienes comparten el quinto lugar. Tras ellas, se encuentran
          Princeton, California Berkeley, Yale y Chicago.
        </p>
        <p>
          Los autores del ranking señalan que el papel que jugó la universidad
          de Oxford, en conjunto con el laboratorio AstraZeneca, en la creación
          de una vacuna contra el Covid, fue uno de sus puntos más fuertes.
          Asimismo, dicen que otras universidades que contribuyeron
          significativamente en investigaciones para contener el coronavirus
          también se beneficiaron en el ranking, con varias instituciones chinas
          al alza: las dos grandes del país, Pekín y Tsinghua, se quedaron en el
          puesto 16, por ser gigantes en investigación.
        </p>
      </Columns>
      <TheWorld />
    </Content>
    <Summary />
  </Layout>
)

export default IndexPage
